import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header-login',
  templateUrl: './header-login.component.html',
  styleUrls: ['./header-login.component.sass']
})
export class HeaderLoginComponent implements OnInit {

  idioma: string;

  currentFlag: any;
  defualtLanguage = 'pt-br';
  languages: any;
  constructor(private translateService: TranslateService, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const stored = localStorage.getItem('lang') || this.defualtLanguage;
    this.useLanguage({ codeIso: stored });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.idioma = event.lang;
      this.setHtmlAttrs(event.lang);
      this.configureLanguage();
    });

    this.configureLanguage();
  }

  useLanguage(lang: any): void {
    const code = lang.codeIso;
    this.translateService.use(code);
    localStorage.setItem('lang', code);
    sessionStorage.setItem('currentLanguage', JSON.stringify(lang));
    this.idioma = code;
    this.currentFlag = lang;
    this.setHtmlAttrs(code);
  }

  private setHtmlAttrs(code: string) {
    const html = this.document.documentElement;
    html.setAttribute('lang', code);
    html.setAttribute('translate', 'no');
    html.classList.add('notranslate');
  }

  public configureLanguage() {
    this.idioma = this.translateService.currentLang || localStorage.getItem('lang') || this.defualtLanguage;
    const storage = sessionStorage.getItem('languages');
    if (storage) {
      this.languages = JSON.parse(storage);
      this.languages?.map((item: any) => item.icon = `assets/img/${item.icon}`);
      this.currentFlag = this.languages?.find((item: any) => item.codeIso == this.idioma);
    }
  }
}
